<div>
    <app-appheader></app-appheader>
    <div class="modalSpinner">
        <div class="wait-loader"></div>
    </div>
</div>